import { useEffect, useState } from 'react'

interface iStoredData {
  data: any,
  expire: number
}

export const useLocalStorage = <T> (key: string, expireInMinutes = 60, initialValue: T | undefined = undefined): [T, (value: T) => void] => {

  const [value, setValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key)
      if (item) {

        const data: iStoredData = JSON.parse(item)
        var now = (new Date()).getTime()
        if (data.expire > now) {
          return data.data
        }
      }
      return initialValue
    } catch (error) {
      console.error(error)
      return initialValue
    }
  })

  useEffect(() => {
    try {
      const now = (new Date()).getTime()
      const data: iStoredData = {
        data: value,
        expire: now + expireInMinutes * 60 * 1000
      }
      window.localStorage.setItem(key, JSON.stringify(data))
    } catch (error) {
      console.error(error)
    }
  }, [value])

  return [value, setValue]
}